import React, {useState} from 'react';
import s from '../MyOrdersForManager.module.css';
import {useTranslation} from 'react-i18next';
import PopupCreateProductCatalog from '../MyOrdersPopups/CreateProductCatalog/PopupCreateProductCatalog';
import {useDeferredInfoQuery} from '../../../redux/userOrdersApi';
import PreLoaderComponent from '../../../assets/Animations/PreLoaderComponent/PreLoaderComponent';
import {formatNumber} from '../../../assets/utils/utils';
import styles from './UserDeferred.module.css';

type Props = {
	onSaveSuccess?: () => void;
};

const UserDeferred: React.FC<Props> = ({onSaveSuccess}) => {
	const {t} = useTranslation();
	const {data, isLoading} = useDeferredInfoQuery();
	const [popupCreateProductCatalog, setPopupCreateProductCatalog] =
		useState(false);

	const handleClosePopup = () => {
		setPopupCreateProductCatalog(false);
	};

	if (isLoading) {
		return <PreLoaderComponent type={'circle'} size={'big'} />;
	}
	if (!data) {
		return <div>{t('Порожній')}</div>;
	}
	if (data && data.user_deferred) {
		return (
			<>
				<div className={styles.userDeferred}>
					<>
						<button
							className={s.pendingOrders}
							onClick={() => setPopupCreateProductCatalog(true)}
						>
							<div className={styles.deferredTop}>
								<div className={styles.deferredIcon}></div>
								<div className={styles.deferredLabel}>
									{t('Оформити відкладені бали')}
								</div>
							</div>
						</button>
						<div className={styles.deferredSum}>
							{formatNumber(data.balance)}
							<span>{t('Бали')}</span>
						</div>
						<div className={styles.deferredInfo}>
							{t('Доступні бали для оформлення')}
						</div>
					</>
				</div>
				{popupCreateProductCatalog && (
					<PopupCreateProductCatalog
						balance={data.balance}
						close={handleClosePopup}
						onSaveSuccess={onSaveSuccess}
					/>
				)}
			</>
		);
	} else return <></>;
};

export default UserDeferred;
